module.exports = __webpack_public_path__ + "img/search_blue.19cf8451.svg";